<template>
	<v-dialog v-model="dialog" width="600">
		<custom-dialog>
			<template v-slot:title>
				{{ 'グループ名変更' }}
				<button id="dialog_exit">
					<img src="@/assets/images/popup_close.png" id="btn_img" @click="dialog = false">
				</button>
			</template>
			<template v-slot:body>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col class="ma-0 pa-0" cols="10">
						<v-row class="ma-0 pa-0 pt-2 mb-10" align="center" justify="center">
							<v-col class="ma-0 pa-0" cols="3">{{ 'グループ名' }}</v-col>
							<v-col class="ma-0 pa-0" cols="9">
								<input class="member_input" v-model="groupName">
							</v-col>
						</v-row>
						<v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
							<v-btn class="ma-0 pa-0" id="grey_btn" @click="dialog = false"
								width="8rem" height="2rem">{{ t('back') }}</v-btn>
							<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="reNameGroup" :loading="loading"
								width="8rem" height="2rem">{{ t('change') }}</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</template>
		</custom-dialog>
	</v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
export default {
	props: {
		dialogVisible: Boolean,
		// 대상 카메라그룹 (groupName/cameras 포함). PATCH 시 cameras 를 함께 보내 보존한다.
		group: { type: Object, default: null },
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
		dialog: false,
		groupName: '',
		loading: false,
	}),
	watch: {
		dialogVisible: function (item) {
			this.dialog = item;
			if (item && this.group) this.groupName = this.group.groupName;
		},
		dialog: function (item) {
			this.$emit('visible', item);
		},
	},
	methods: {
		reNameGroup() {
			if (this.groupName === '' || this.checkStringOnlyBlankPattern(this.groupName)
				|| this.checkStringBlankPattern(this.groupName)) {
				this.showToastMessage('名前の形式が無効です。');
				return;
			}
			if (!this.group) return;
			this.loading = true;
			// cameras 를 함께 보내 기존 카메라 구성을 보존한다. (updateCameraCheckListGroup PATCH)
			const params = {
				groupName: this.groupName,
				// cameras: this.group.cameras || [],
			};
			this.networkController.updateCameraCheckListGroup(params, this.group.id)
				.then(() => {
					this.showToastMessage(this.tmb('requestSuccess'));
					this.loading = false;
					this.$emit('success', this.groupName);
					this.dialog = false;
				}).catch(() => {
					this.showToastMessage(this.tmb('requestFail'));
					this.loading = false;
				});
		}
	}
}
</script>

<style lang="scss" scoped>
.member_input {
	width: 100%;
	padding-left: 1em;
	color: white;
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 3px;
	height: 2rem;
}
</style>
